const turboslots = {
    themeName: 'turboslots',
    brand: 'Turboslots',
    font: {
        main: ['DM Sans', 'sans-serif'],
        alternative: ['Inter', 'sans-serif'],
        'alternative-2': ['Poppins', 'sans-serif'],
        'alternative-3': ['Montserrat', 'sans-serif']
    },
    color: {
        primary: {
            '100': '#f564b4',
            '300': '#F9CE28',
            '500': '#BE2F49',
            '700': '#BE2F49',
            '900': '#8E0550'
        },
        secondary: {
            '100': '#2A2A2A',
            '300': '#18192F',
            '500': '#FFFFFF1A',
            '700': '#18192F',
            '900': '#18192F'
        },
        tertiary: {
            '100': '#18192F',
            '300': '#18192F',
            '500': '#FFFFFF1A',
            '700': '#FFFFFF0D',
            '900': '#FFFFFF0D'
        },
        accent: {
            '100': '#FFFFFF',
            '300': '#D4D4D4',
            '500': '#F19738',
            '700': '#F19738',
            '900': '#18192F'
        },
        neutral: {
            '100': '#FFFFFF26',
            '300': '#FFFFFF33',
            '500': '#FFFFFF0D',
            '700': '#FFFFFF1A',
            '900': '#FFFFFF26'
        },
        background: {
            '100': '#0A061F',
            '300': '#1A090B',
            '500': '#FFFFFF0D',
            '700': '#FFFFFF0D',
            '900': '#1A090B'
        },
        success: {
            '100': '#FFF4CC',
            '300': '#FBE487',
            '500': '#F5DB53',
            '700': '#4EFF2A',
            '900': '#8C6F00'
        },
        warning: {
            '100': '#FDF3E0',
            '300': '#F4B84A',
            '500': '#EE9016',
            '700': '#C97810',
            '900': '#0D0F19'
        },
        error: {
            '100': '#BE2F49',
            '300': '#E67777',
            '500': '#F19738',
            '700': '#991E1E',
            '900': '#5A0E0E'
        },
        info: {
            '100': '#FFFFFF99',
            '300': '#89C3F2',
            '500': '#2C92CB',
            '700': '#1C5F8A',
            '900': '#0B2C40'
        },
        text: {
            '100': '#FFFFFF',
            '300': '#D4D4D4',
            '500': '#A3A3A3',
            '700': '#F9CE28',
            '900': '#FFFFFF'
        },
        highlight: {
            '1': '#F9CE28',
            '2': '#F19738',
            '3': '#0c071dfc',
            '4': 'transparent',
            '5': '#0C071DCC'
        }
    },
    gradients: {
        main: {
            type: 'linear',
            angle: '180deg',
            stops: [
                { token: 'color.background.100', at: '0%' },
                { token: 'color.background.300', at: '100%' }
            ]
        },
        alternative: {
            type: 'linear',
            angle: '180deg',
            stops: [
                { token: 'color.background.300', at: '0%' },
                { token: 'color.background.500', at: '100%' }
            ]
        },
        'alternative-2': {
            type: 'linear',
            angle: '180deg',
            stops: [
                { token: 'color.background.300', at: '0%' },
                { token: 'color.background.500', at: '100%' }
            ]
        },
        'alternative-3': {
            type: 'linear',
            angle: '180deg',
            stops: [
                { token: 'color.background.100', at: '0%' },
                { token: 'color.background.500', at: '100%' }
            ]
        },
        'alternative-4': {
            type: 'linear',
            angle: '180deg',
            stops: [
                { token: 'color.background.500', at: '0%' },
                { token: 'color.background.900', at: '100%' }
            ]
        },
        'alternative-5': {
            type: 'linear',
            angle: '180deg',
            stops: [
                { token: 'color.background.500', at: '0%' },
                { token: 'color.background.900', at: '100%' }
            ]
        },
        'alternative-6': {
            type: 'linear',
            angle: '180deg',
            stops: [
                { token: 'color.background.100', at: '0%' },
                { token: 'color.background.700', at: '100%' }
            ]
        },
        primary: {
            type: 'linear',
            angle: '180deg',
            stops: [
                { token: 'color.primary.500', at: '0%' },
                { token: 'color.primary.900', at: '100%' }
            ]
        },
        'primary-2': {
            type: 'linear',
            angle: '180deg',
            stops: [
                { token: 'color.primary.500', at: '0%' },
                { token: 'color.primary.900', at: '100%' }
            ]
        },
        'primary-dark': {
            type: 'linear',
            angle: '180deg',
            stops: [
                { token: 'color.primary.500', at: '0%' },
                { token: 'color.primary.900', at: '100%' }
            ]
        },
        secondary: {
            type: 'linear',
            angle: '180deg',
            stops: [
                { token: 'color.secondary.500', at: '0%' },
                { token: 'color.secondary.700', at: '100%' }
            ]
        },
        'secondary-light': {
            type: 'linear',
            angle: '180deg',
            stops: [
                { token: 'color.primary.100', at: '0%' },
                { token: 'color.primary.500', at: '100%' }
            ]
        },
        accent: {
            type: 'linear',
            angle: '180deg',
            stops: [
                { token: 'color.accent.300', at: '0%' },
                { token: 'color.accent.500', at: '100%' }
            ]
        },
        success: {
            type: 'linear',
            angle: '180deg',
            stops: [
                { token: 'color.success.500', at: '0%' },
                { token: 'color.success.900', at: '100%' }
            ]
        },
        error: {
            type: 'linear',
            angle: '180deg',
            stops: [
                { token: 'color.error.500', at: '0%' },
                { token: 'color.error.700', at: '100%' }
            ]
        },
        'error-2': {
            type: 'linear',
            angle: '180deg',
            stops: [
                { token: 'color.error.300', at: '0%' },
                { token: 'color.error.700', at: '100%' }
            ]
        },
        christmas: {
            type: 'linear',
            angle: '180deg',
            stops: [
                { token: 'christmas.2', at: '0%' },
                { token: 'christmas.1', at: '100%' }
            ]
        },
        'christmas-2': {
            type: 'linear',
            angle: '180deg',
            stops: [
                { token: 'christmas.3', at: '0%' },
                { token: 'christmas.4', at: '100%' }
            ]
        }
    },
    borderRadius: {
        button: { default: '8px', small: '8px' },
        input: { default: '12px', message: '8px' },
        header: { chatNotifications: '8px', profile: '24px', toggle: '50%', vip: '41px' },
        promotions: { item: '8px' }
    },
    components: {
        tabs: {
            'alternative4-active-background': '#FFFFFF1A',
            'alternative4-active-text': 'color.text.100',
            'alternative4-inactive-background': '#FFFFFF0D',
            'alternative4-inactive-text': 'color.text.100',
            'alternative4-inactive-background-hover': '#FFFFFF14'
        },
        button: {
            'tertiary-alternative-4-background': 'color.primary.700',
            'tertiary-alternative-4-background-hover': 'color.primary.900',
            'tertiary-alternative-4-text': 'color.text.100'
        },
        error: { background: 'color.error.500', text: 'color.text.100' },
        footer: { social: 'color.background.700' },
        info: { background: 'color.info.500', text: 'color.text.100' },
        input: {
            background: 'color.tertiary.700',
            border: 'transparent',
            'border-hover': 'transparent',
            'border-active': 'transparent'
        },
        progress: {
            background: '#00091B',
            'background-2': 'color.background.900',
            fill: 'linear-gradient(180deg, #FFCD2A 0%, #E28713 100%)',
            'fill-2': 'color.highlight.2',
            'fill-2-shadow': 'color.highlight.2',
            'fill-shadow': 'color.primary.500'
        },
        success: { background: 'color.success.500', text: 'color.text.100' },
        table: { 'odd-row': '#222040' },
        warning: { background: 'color.warning.500', text: 'color.warning.900' },
        sportmodity: {
            background: '#1A090B',
            foreground: 'color.text.100',
            primary: 'color.primary.500',
            'primary-foreground': 'color.text.100',
            selection: 'color.primary.500',
            'selection-foreground': 'color.text.100',
            outcome: '#404040',
            'outcome-foreground': 'color.text.100',
            card: 'color.secondary.100',
            'card-foreground': 'color.text.100',
            border: 'color.neutral.700',
            radius: 'borderRadius.button.default',
            secondary: 'color.secondary.100',
            'secondary-foreground': 'color.text.100',
            popover: 'color.secondary.100',
            'popover-foreground': 'color.text.100',
            muted: '#404040',
            'muted-foreground': 'color.text.300',
            input: 'color.secondary.100',
            accent: 'color.accent.500',
            success: 'color.success.500',
            warning: 'color.warning.500',
            error: 'color.error.500'
        },
        'home-page': {
            'text-banner01': {
                'cta-button-bg': '#BE2F49',
                'cta-button-text': '#FFFFFF',
                'status-dot-bg': '#4EFF2A',
                'banner-title-highlight': '#FFCD2A'
            },
            'text-banner02': {
                'btn1-bg': '#FFFFFF',
                'btn2-bg': '#FFFFFF',
                'card1-bg-from': '#F4B23F',
                'card1-bg-to': '#F19738',
                'card2-bg-from': '#82172B',
                'card2-bg-to': '#BE2F49'
            },
            'turbo-jackpot-drop': {
                'main-jackpot-gradient-from': '#f29026',
                'main-jackpot-gradient-to': '#e05f1f',
                'jackpot-label': 'color.text.100',
                'jackpot-value': 'color.text.100',
                'view-all-link': '#f4b23f',
                'view-all-link-hover': '#ffc75f'
            }
        },
        'casino-slots-banner': {
            'card1-bg-from': '#F4B23F',
            'card1-bg-to': '#F19738',
            'card1-title-color': '#000000',
            'card1-desc-color': '#000000',
            'card1-btn-bg': '#FFFFFF',
            'card1-btn-text': '#000000',
            'card2-bg-from': '#82172B',
            'card2-bg-to': '#BE2F49',
            'card2-title-color': '#FFFFFF',
            'card2-desc-color': '#FFFFFF',
            'card2-btn-bg': '#FFFFFF',
            'card2-btn-text': '#ad2941'
        },
        'banner-swiper': {
            'banner-fixed': {
                'regular-color': '#FFCD2A',
                'text-light': '#FFFFFF',
                'text-dark': '#0F121E',
                'sub01-bg': '#DA4A48',
                'sub02-bg': '#5D48DA'
            }
        },
        layout: {
            'body-bg': 'linear-gradient(180deg, #0A061F 0%, #1A090B 100%)',
            'side-bar-bg': '#0F092E33',
            'footer-bg': '#0D0F1A'
        },
        'side-bar': {
            'dropdown-sport-active-bg': '#F19738',
            'dropdown-sport-active-text': '#000000',
            'dropdown-casino-active-bg': '#BE2F49',
            'dropdown-casino-active-text': '#FFFFFF',
            'dropdown-side-bar-item-bg': '#2A2B45'
        },
        'game-promo-card': {
            'badge-jackpot-bg': '#DA4A48',
            'badge-jackpot-text': 'color.secondary.300',
            'badge-promoted-bg': '#5D48DA',
            'badge-promoted-text': 'color.text.100'
        },
        'vip-dashboard': {
            'your-rank': {
                //--component-vip-dashboard-your-rank-*
                'card-bg': 'color.background.500',
                'text-primary': 'white',
                'rank-text': '#FFFFFF',
                surface: 'color.background.500',
                'label-muted': '#959595',
                'bar-bg': '#2f2f2f',
                'bar-from': '#FFCD2A',
                'bar-to': '#E28713',
                'label-dim': '#959595',
                'label-above': '#959595',
                'reward-text': '#F9CE28'
            },
            'all-ranks': {
                //--component-vip-dashboard-all-ranks-*
                'card-bg': 'color.background.500',
                'text-primary': 'white',
                'rank-text': '#ccdee6',
                'bar-from': '#FFCD2A',
                'bar-to': '#E28713',
                'label-muted': '#848484',
                'progress-bg': '#00091B'
            },
            modal: {
                'body-bg': 'rgb(255 255 255 / 0.05)'
            }
        },
        'about-vip': {
            //--component-about-vip-vip-rank-rewards-*
            'vip-rank-rewards': {
                'table-bg': 'color.background.500',
                'odd-row-bg': 'color.background.500',
                'table-header-bg': 'unset',
                'table-side-bg': 'unset'
            }
        },
        'header-profile': {
            'frame-background': 'color.background.500',
            'toggle-background': 'color.background.500',
            'progress-color': 'color.accent.700',
            'notification-background': 'color.accent.700',
            'notification-text': '#000000'
        }
    },
    boxShadows: {
        neutral: '0px 5px 6px 0px #00000040 inset, 0px -5px 6px 0px #FFFFFF16 inset',
        inner: '0px 0px 8px 0px #00000099',
        vip: '0px 0px 8px 0px #ffffff7a'
    },
    maxHeight: { zero: '0', full: '100%' },
    transitions: { maxHeight: 'max-height', rotate: 'transform' },
    rotate: { '360': '360deg' },
    width: { fitContent: 'fit-content', width15: '3.70rem', chatWidth: '240px' },
    height: { height15: '3.70rem' },
    screens: { xs390: '390px', customSm: '580px', custom720: '720px' },
    christmas: {
        '1': '#B00404',
        '2': '#FD5757',
        '3': '#FED234',
        '4': '#FF952B',
        '5': '#61370D',
        '6': '#FF9E14',
        '7': '#0F2985'
    },
    vip: { '1': 'color.highlight.3', '2': 'color.highlight.3' }
};
export default turboslots;
